exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-form .logo[data-v-12e35b09]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;cursor:pointer}.search-form .logo .logo-img[data-v-12e35b09]{width:40px;height:40px}.search-form .logo .logo-img img[data-v-12e35b09]{width:100%;height:100%}", ""]);

// exports
